const TestPage = () => {

    return (
        <iframe id="pdf-js-viewer" src="http://localhost/smartlearning/pdfjs/web/viewer.html?file=http://localhost/smartlearning/pdfjs/test.pdf" title="webviewer" frameBorder="0" width="500" height="600"></iframe>
    )
}

export default TestPage